"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactTabs = require("react-tabs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 0.5rem 1rem;\n\tmargin: 0;\n\tcolor: ", ";\n\tcursor: pointer;\n\tborder-bottom: 3px solid transparent;\n\n\t&.react-tabs__tab--selected {\n\t\tborder-bottom: 3px solid ", ";\n\t\toutline: none;\n\t\tcursor: default;\n\t\tfont-family: ", ";\n\t}\n\n\t&[aria-disabled='true'] {\n\t\tcursor: not-allowed;\n\t\topacity: 0.6;\n\t}\n\n\t&:hover {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledTab = (0, _styledComponents.default)(_reactTabs.Tab)(_templateObject(), _colors.default.primaryDarker, _colors.default.primaryDarker, _vars.default.fontStackBold, _colors.default.linkHover);
StyledTab.displayName = 'StyledTab';
StyledTab.tabsRole = 'Tab';
/** @component */

var _default = StyledTab;
exports.default = _default;